/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:29
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:16:20
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\center\mutations.js
 */
import * as MUTATIONTYPES from '../mutationTypes'
import * as STATETYPES from '../stateTypes'
const mutations = {
	[MUTATIONTYPES.SETCENTERNAME](state, data) {
		state[STATETYPES.CENTERNAME] = data
	}
}
export default mutations